module.exports = __webpack_public_path__ + "static/fonts/iconfont.e995dd08.ttf";